import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { responsive } from "@huub-web/ui/utils/responsive";

export const containerStyle = recipe({
  base: {
    // Ensure proper overflow handling for parallax effect
    overflow: "hidden",
  },
  variants: {
    ratio: {
      "1/1.3": {
        aspectRatio: "1/1",
        ...responsive({
          m: {
            aspectRatio: "1/1.3",
          },
        }),
      },
    },
  },
});

export const imageStyle = style({
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  willChange: "transform",
  backfaceVisibility: "hidden",
});

export const contentStyle = recipe({
  variants: {
    justifyContent: {
      "flex-start": {
        justifyContent: "flex-start",
      },
      "flex-end": {
        justifyContent: "flex-end",
      },
      center: {
        justifyContent: "center",
      },
      "space-between": {
        justifyContent: "space-between",
      },
    },
  },
});
